import React from 'react'
import styled from 'styled-components'

import CheckIcon from '@Assets/SVG/Check'
import StarBgIcon from '@Assets/SVG/StarBg'
import { SVGIcon } from '@Components/Icons'
import { box, flexCenterChildren } from '@Globals/Style/mixins'
import { useTranslation } from '@Globals/Translations'

interface WrapperProps {
  iconBackgroundStrokeColor?: string
  iconMainFillColor?: string
}

const Wrapper = styled.div<WrapperProps>`
  display: flex;
  margin-top: 10px;

  .icon-wrapper {
    position: relative;
    ${box({ width: '70px' })}
    flex-shrink: 0;
    margin: 0 auto;
  }

  .icon {
    ${box({ width: '100%' })}
    position: absolute;
    top: 0;
    left: 0;
  }

  .icon-background svg {
    ${box({ width: '100%' })}
    fill: transparent;
    stroke-width: 10px;
    stroke: ${({ iconBackgroundStrokeColor, theme }) => iconBackgroundStrokeColor
      ?? theme.colors.primary};
  }

  .icon-main {
    ${flexCenterChildren}
    svg {
      fill: ${({ iconMainFillColor, theme }) => iconMainFillColor ?? theme.colors.primary};
    }
  }

  .text {
    margin-left: 10px;
  }

  .title {
    font-weight: 700;
  }
`

export const NewsletterSubscribed = () => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <div className="icon-wrapper">
        <div className="icon icon-background">
          <SVGIcon icon={StarBgIcon} size="70px" />
        </div>
        <div className="icon icon-main">
          <SVGIcon icon={CheckIcon} size="35px" />
        </div>
      </div>

      <div className="text">
        <p className="title">{t('footer:FOOTER_SIGN_UP_SUCCESS_TITLE')}</p>
        <p>{t('footer:FOOTER_SIGN_UP_SUCCESS_WELCOME')}</p>
        <p>{t('footer:FOOTER_SIGN_UP_SUCCESS_FIRST_MAIL')}</p>
      </div>
    </Wrapper>
  )
}
